import { popBreadcrumbs } from 'BreadcrumbNavigation';
import { isBreadcrumbBackNavTargetPath } from './learningPathMatchers';

export function popLearningBreadcrumbs(currentPath: string, defaultPath = '/dashboard'): string {
    return popBreadcrumbs({
        section: 'learning',
        default: defaultPath,
        filter: isBreadcrumbBackNavTargetPath,
        currentPath: currentPath ?? '',
    });
}
